import { useEffect } from "react";

// Link "Vedi sul sito" dal pannello: /?scheda=<key>#sezione apre direttamente la scheda prodotto.
export const useOpenFromUrl = (items, setOpen) => {
    useEffect(() => {
        const key = new URLSearchParams(window.location.search).get("scheda");
        if (!key) return;
        const item = items.find((p) => p.key === key);
        if (item) {
            setOpen(item);
            window.history.replaceState(null, "", window.location.pathname + window.location.hash);
        }
    }, [items, setOpen]);
};
